import { render } from "./ForgetPswdPage.vue?vue&type=template&id=0da9920a"
import script from "./ForgetPswdPage.vue?vue&type=script&lang=js"
export * from "./ForgetPswdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__